import { inject, Injectable } from '@angular/core';
import { DataContextService, ResultWrapper } from '@seahorse/common';
import { ProductModel, ProfileModel } from '@seahorse/domain';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileDataService {
  private readonly _baseUrl = 'profiles';
  private _dataContextService = inject(DataContextService);

  getProfiles(
    pageIndex: number,
    pageSize: number,
    organisationId: Guid
  ): Observable<ResultWrapper<ProfileModel[]>> {
    return this._dataContextService.get<ProfileModel[]>(
      `${this._baseUrl}?organisationId=${organisationId}&pindex=${pageIndex}&psize=${pageSize}`
    );
  }

  addProfile(model: ProfileModel): Observable<ResultWrapper<ProfileModel>> {
    return this._dataContextService.post<ProfileModel>(this._baseUrl, model);
  }

  updateProfile(model: ProfileModel): Observable<ResultWrapper<ProfileModel>> {
    return this._dataContextService.put<ProfileModel>(
      `${this._baseUrl}/${model.id}`,
      model
    );
  }

  getProducts(): Observable<ResultWrapper<ProductModel[]>> {
    return this._dataContextService.get<ProductModel[]>(
      `${this._baseUrl}/products`
    );
  }

  getUsers(): Observable<ResultWrapper<ProductModel[]>> {
    return this._dataContextService.get<ProductModel[]>(
      `${this._baseUrl}/users/`
    );
  }

  delete(id: number): Observable<ResultWrapper<void>> {
    return this._dataContextService.delete<void>(`${this._baseUrl}/${id}`);
  }
}
